import BlockRenderer from './BlockRenderer.jsx';
import { CanvasThemeProvider } from './ThemeContext.jsx';
import { useEditor } from './editorStore.js';

export default function PreviewModal({ open, onClose, site }) {
  const blocks = useEditor((s) => s.blocks);
  const device = useEditor((s) => s.device);

  if (!open) return null;

  const width = device === 'mobile' ? 420 : device === 'tablet' ? 820 : 1100;
  const fontFamily = site?.theme?.fontFamily || 'Inter, system-ui, sans-serif';

  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-ink-950/80 p-6">
      <div className="card flex h-full max-h-[90vh] w-full max-w-6xl flex-col overflow-hidden">
        <div className="flex items-center justify-between border-b border-ink-200 px-5 py-3 dark:border-ink-800">
          <div className="text-sm font-semibold">Preview · {device}</div>
          <button onClick={onClose} className="btn-ghost h-8 w-8 p-0">×</button>
        </div>
        <div className="scroll-pane flex-1 overflow-auto bg-ink-100 p-6 dark:bg-ink-950">
          <div
            style={{
              maxWidth: width,
              margin: '0 auto',
              background: '#fff',
              borderRadius: 12,
              overflow: 'hidden',
              fontFamily,
            }}
          >
            <CanvasThemeProvider value={site?.theme}>
              <BlockRenderer blocks={blocks} />
            </CanvasThemeProvider>
          </div>
        </div>
      </div>
    </div>
  );
}
